import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';

import { IonButtons, IonContent, IonHeader, IonTitle, IonToolbar, ModalController } from '@ionic/angular/standalone';

import { Address } from '@guardfinder/address';

import { IconButtonComponent } from '../../buttons';
import { SvgIconComponent } from '../../icons';
import { PlacesAutocompleteInputComponent } from '../../inputs';
import { UseMyLocationComponent } from '../../use-my-location/use-my-location-component.component';

export type LocationModalSelectorComponentResponse = {
    address: Address;
};

@Component({
    selector: 'lib-location-modal-selector',
    imports: [
        CommonModule,
        IonContent,
        PlacesAutocompleteInputComponent,
        IonHeader,
        IonToolbar,
        IonTitle,
        IonButtons,
        IconButtonComponent,
        SvgIconComponent,
        UseMyLocationComponent
    ],
    templateUrl: './location-modal-selector.component.html',
    styleUrl: './location-modal-selector.component.css'
})
export class LocationModalSelectorComponent {
    private readonly modalCtrl = inject(ModalController);

    async onAddressSelected(address: Address) {
        await this.modalCtrl.dismiss({ address }, 'confirm');
    }

    closeModal(): Promise<boolean> {
        return this.modalCtrl.dismiss();
    }

    async onPlacesAddressSelect(address: Address) {
        if (!address) return;
        await this.modalCtrl.dismiss({ address }, 'confirm');
    }
}
